import React from "react";
import { useRouter } from "next/router";
import { observer } from "mobx-react-lite";
import { Hooks } from "@xt/xtbase";
import { Drawer } from "antd";
import { getCfdSpotConvertPath } from "@/components/Pages/Convert/convertResultShared";
import styles from "./index.module.scss";

const { useTranslation } = Hooks;

export interface DepositOrConvertDrawerProps {
  open: boolean;
  onClose: () => void;
  /** 是否法币本位合约：法币本位 -> 闪兑跳 Spot Tab?tab=sell；U 本位 -> Spot Tab */
  isFiatContract: boolean;
  /** 用户选择「充值法币」时回调（由调用方执行跳转或打开充值 Drawer） */
  onChooseDeposit: () => void;
}

const DepositOrConvertDrawer: React.FC<DepositOrConvertDrawerProps> = ({
  open,
  onClose,
  isFiatContract,
  onChooseDeposit,
}) => {
  const t = useTranslation();
  const router = useRouter();

  const handleDeposit = () => {
    onClose();
    onChooseDeposit();
  };

  const handleConvert = () => {
    onClose();
    const query = isFiatContract ? { tab: "sell" } : {};
    router.push(getCfdSpotConvertPath(query));
  };

  return (
    <Drawer
      placement="bottom"
      closable={false}
      open={open}
      onClose={onClose}
      className={styles.drawer}
      destroyOnClose
      title={
        <div className={styles.drawerHeader}>
          <span className={styles.headerTitle}>{t("cfd.marginDeposit")}</span>
          <button type="button" className={styles.closeBtn} onClick={onClose} aria-label={t("cancel")}>
            <svg className={styles.closeIcon} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm-2.634-4.234L8 9.13l2.634 2.635 1.132-1.132L9.132 8l2.634-2.634-1.132-1.132L8 6.87 5.366 4.234 4.235 5.366 6.869 8l-2.635 2.634 1.132 1.132Z"
                fill="currentColor"
              />
            </svg>
          </button>
        </div>
      }
    >
      <div className={styles.content}>
        <button type="button" className={styles.option} onClick={handleDeposit}>
          <span className={styles.optionText}>{isFiatContract ? t("cfd.depositFiat") : t("cfd.depositUsdt")}</span>
        </button>
        <button type="button" className={styles.option} onClick={handleConvert}>
          <span className={styles.optionText}>{t("cfd.quickConvert")}</span>
        </button>
      </div>
    </Drawer>
  );
};

export default observer(DepositOrConvertDrawer);
